import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ssp',
  templateUrl: './ssp.component.html',
  styleUrls: ['./ssp.component.scss']
})
export class SSPComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
